import {Action, configureStore} from '@reduxjs/toolkit';
import {createEpicMiddleware, Epic} from 'redux-observable';

import {batchMiddleware} from './middlewares';
import {epicDeps, thunkExtra} from './deps';
import {rootEpic, rootReducer} from './root';

const epicMiddleware = createEpicMiddleware({
    dependencies: epicDeps,
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: {
                extraArgument: thunkExtra,
            },
        }).concat(epicMiddleware, batchMiddleware),
    preloadedState: window.__STATE__ || {},
    devTools: process.env.NODE_ENV !== 'production',
});

epicMiddleware.run(rootEpic as Epic<Action>);

export * from './root';
export type {WikiState, WikiDispatch} from './types';
